import hatsApi from '@/services/hatsApi'

export default {
  getReservationLines (params, pageSize = '', page = '', sort = '') {
    let filter = params || []
    let pagination = ''
    let sorting = ''
    if (sort) {
      sorting = '&sort=' + sort
    }
    if (pageSize) {
      pagination += `&pageSize=${pageSize}`
    }
    if (page) {
      pagination += `&page=${page}`
    }
    return hatsApi().get(`/operational/reservation_line?filter=${JSON.stringify(filter)}${pagination}${sorting}`)
  },
  sendConfirmationEmailToTheHotel (reservationLineId) {
    return hatsApi().put(`/operational/reservation-confirm/email/${reservationLineId}`)
  },
  sendPassportDataRequestToCustomer (reservationId) {
    return hatsApi().put(`/operational/reservation-ask-passport-data/email/${reservationId}`)
  },
  sendGroupDetailsRequestToCustomer (reservationId) {
    return hatsApi().put(`/operational/reservation-ask-group-details/email/${reservationId}`)
  },
  bedsCacheExists (params) {
    return hatsApi().post(`/operational/reservation-line-beds-cache-exists`, params)
  },
  puppeteerBooking (params) {
    return hatsApi().post(`/operational/reservation-line-puppeteer-booking`, params)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/ReservationLine.js